// /api/master/sla Array
export interface MasterSlaApiResponse {
    sla_id: string;
    sla_name: string;
}

export const MASTER_SLA_INIT = {
    sla_id: '',
    sla_name: '',
};

// API ERROR
export const MASTER_SLA_API_ERRORS = {
    REQUEST_ERROR_9003: 'REQUEST_ERROR(9003)',
    REQUEST_ERROR_9003_STATUS_CODE: 'REQUEST_ERROR(9003)_%1',
};
